/* -------------------------------------------------------------------------------------------------
Restricted - Copyright (C) Siemens Healthcare GmbH/Siemens Medical Solutions USA, Inc., 2020. All rights reserved
------------------------------------------------------------------------------------------------- */

import { html, LitElement } from 'lit-element';
import spinnerStyles from './sh-spinner.lit.scss.js';

/**
 * @prop {String} label - Defines the label that will be displayed below the spinner.
 * @prop {String} size - Default m. Defines the size of the spinner. Possible values are `m` (3rem) and `s` (2rem).
 * @prop {Boolean} overlay - Default false. If set to `true`, the spinner will appear over an overlay on top of the page.
 */
export class SHSpinner extends LitElement {
  static get properties() {
    return {
      label: {
        type: String,
        reflect: true,
      },
      size: {
        type: String,
        reflect: true,
      },
      overlay: {
        type: Boolean,
        reflect: true,
      },
    };
  }

  static get styles() {
    return [spinnerStyles];
  }

  render() {
    return html`
      <div class="loader"></div>
      ${this.label ? html` <div class="spinner-label">${this.label}</div> ` : ''}
    `;
  }

  constructor() {
    super();
    this.size = 'm';
  }
}

customElements.define('sh-spinner', SHSpinner);
